import { useState } from "react";

import {
  Backdrop,
  Box,
  CircularProgress,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import azureLogo from "assets/icons/azure.svg";
import { Button, SEO, Typography } from "components";
import { base, gray } from "configs/colors";
import { useAuth } from "hooks";
import { TLNTab } from "pages/Components";
import i18n from "translations/i18n";
import { getPrimaryColor } from "utils/theme";

import content from "./assets/images/banner.png";
import { useSignIn } from "./hooks";
import OTPLogin from "./OTPLogin";
import PasswordLogin from "./PasswordLogin";
import {
  AzureIcon,
  ContentImage,
  FormContainer,
  LeftSection,
  ORButton,
  ORContainer,
  ORDivider,
  PageContainer,
  RightSection,
} from "./styles";

const IndexPage = () => {
  const theme = useTheme();
  const [tab, setTab] = useState("email");
  const mdUpMatched = useMediaQuery(theme.breakpoints.up("md"));

  const { isFetching } = useAuth();

  const {
    handleLoginViaAzure,
    handleLoginPassword,
    handleLoginWithOTP,
    isLoading,
  } = useSignIn();

  return (
    <>
      <SEO title="Sign In" />
      <PageContainer>
        <LeftSection mdUpMatched={mdUpMatched}>
          <Box
            margin={2}
            flex={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <FormContainer>
              <Typography type="DisplayMD" fontWeight={600}>
                {i18n.t("logIn")}
              </Typography>
              <Typography
                type="TextMD"
                color={gray[600]}
                marginTop={3}
                marginBottom={8}
              >
                {i18n.t("welcomeBackPleaseEnterYourCredential")}
              </Typography>
              <TLNTab.Context
                onChange={(e) => setTab(e)}
                keepTabpanel={false}
                listTab={[
                  {
                    labelI18n: "password",
                    value: "email",
                    component: (
                      <PasswordLogin
                        onLogin={handleLoginPassword}
                        loading={isLoading}
                      />
                    ),
                  },
                  {
                    labelI18n: "OTP",
                    value: "password",
                    component: (
                      <OTPLogin
                        onLogin={handleLoginWithOTP}
                        loading={isLoading}
                      />
                    ),
                  },
                ]}
                value={tab}
              />

              <ORContainer>
                <ORDivider />
                <ORButton variant="outlined" color="inherit" size="medium">
                  OR
                </ORButton>
                <ORDivider />
              </ORContainer>
              <Button
                size="lg"
                useTypography
                typographyProps={{ color: base.White }}
                startIcon={<AzureIcon src={azureLogo} alt="Azure" />}
                fullWidth
                onClick={handleLoginViaAzure}
              >
                {i18n.t("signInWithAzure")}
              </Button>
            </FormContainer>
          </Box>
          <Box padding={mdUpMatched ? 8 : 2}>
            <Typography
              type="TextSM"
              color={mdUpMatched ? gray[600] : getPrimaryColor()[200]}
            >
              © Talentnet 2024
            </Typography>
          </Box>
        </LeftSection>

        {mdUpMatched ? (
          <RightSection>
            <ContentImage src={content} alt="Content" />
          </RightSection>
        ) : null}
      </PageContainer>
      <Backdrop
        sx={{ color: base.White, zIndex: (t) => t.zIndex.drawer + 1 }}
        open={isFetching}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default IndexPage;
